// -----------------------------------------------------------
// FloraIQ - PointCloudQualityPanel — Aba Qualidade e Metadados
// -----------------------------------------------------------

import { useState } from "react";
import { qualityRules, qualityAlertCards } from "@/mocks/pointcloud";

export default function PointCloudQualityPanel() {
  const [validated, setValidated] = useState(false);

  const handleValidate = () => {
    setValidated(false);
    setTimeout(() => setValidated(true), 1200);
  };

  return (
    <div className="space-y-5">
      {/* Cards de alerta */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {qualityAlertCards.map((card) => (
          <div key={card.title} className="bg-white rounded-card border border-background-200/70 p-3">
            <div className="flex items-center gap-2.5">
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${
                card.color === "danger" ? "bg-red-100 text-red-600" :
                card.color === "warning" ? "bg-amber-100 text-amber-600" :
                "bg-green-100 text-green-600"
              }`}>
                <i className={`${card.icon} text-sm`}></i>
              </div>
              <div className="min-w-0">
                <p className="text-xs text-foreground-500 truncate">{card.title}</p>
                <p className="text-sm font-bold text-foreground-900 font-heading">{card.value}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Botão validar */}
      <div className="flex items-center gap-3">
        <button
          onClick={handleValidate}
          className="btn-primary text-xs px-4 py-2 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-check-double-line mr-1.5"></i>
          Executar validação metodológica
        </button>
        {validated && (
          <span className="text-xs text-green-600 flex items-center gap-1 slide-up">
            <i className="ri-check-line"></i> Validação concluída — 24 nuvens analisadas
          </span>
        )}
      </div>

      {/* Tabela de regras */}
      <div className="bg-white rounded-card border border-background-200/70 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-200/70 bg-background-50/50">
                <th className="text-left px-3 py-2.5 text-xs font-medium text-foreground-500">Regra</th>
                <th className="text-left px-3 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Total Avaliado</th>
                <th className="text-left px-3 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Conformes</th>
                <th className="text-left px-3 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Inconformes</th>
                <th className="text-left px-3 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Percentual</th>
                <th className="text-left px-3 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Prioridade</th>
                <th className="text-left px-3 py-2.5 text-xs font-medium text-foreground-500">Ação Recomendada</th>
              </tr>
            </thead>
            <tbody>
              {qualityRules.map((r) => (
                <tr key={r.id} className="border-b border-background-100/50 hover:bg-background-50/30 transition-colors">
                  <td className="px-3 py-2.5 text-xs text-foreground-700 max-w-[280px]">{r.regra}</td>
                  <td className="px-3 py-2.5 text-xs text-foreground-600 whitespace-nowrap">{r.totalAvaliado}</td>
                  <td className="px-3 py-2.5 text-xs text-green-600 font-medium whitespace-nowrap">{r.conformes}</td>
                  <td className="px-3 py-2.5 text-xs text-red-600 font-medium whitespace-nowrap">{r.inconformes}</td>
                  <td className="px-3 py-2.5">
                    <div className="flex items-center gap-2">
                      <div className="flex-1 max-w-[60px] h-1.5 bg-background-100 rounded-full overflow-hidden">
                        <div
                          className={`h-full rounded-full transition-all duration-500 ${r.percentual >= 90 ? "bg-green-500" : r.percentual >= 75 ? "bg-amber-500" : "bg-red-500"}`}
                          style={{ width: `${r.percentual}%` }}
                        ></div>
                      </div>
                      <span className="text-xs font-medium text-foreground-700">{r.percentual}%</span>
                    </div>
                  </td>
                  <td className="px-3 py-2.5">
                    <span className={`inline-flex items-center px-2 py-0.5 text-[10px] font-medium rounded-full border whitespace-nowrap ${
                      r.prioridade === "critica" ? "bg-red-100 text-red-700 border-red-200" :
                      r.prioridade === "alta" ? "bg-orange-50 text-orange-700 border-orange-200" :
                      r.prioridade === "media" ? "bg-amber-50 text-amber-700 border-amber-200" :
                      "bg-green-50 text-green-700 border-green-200"
                    }`}>
                      {r.prioridade}
                    </span>
                  </td>
                  <td className="px-3 py-2.5 text-xs text-foreground-500 max-w-[220px]">{r.acaoRecomendada}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}